import React from "react";
import { Link } from "react-router-dom";

const Description = ({ name, d1, d2, d3, d4, d5, d6, live, git }) => {
  return (
    <div className="lg:ml-10 lg:mt-20 ">
      <h2 className="text-4xl mt-5 lg:mb-10 ">
        <span>{name}</span>
      </h2>
      <h1 className="relative h1 lg:py-4 lg:text-xl border my-3 px-4 border-secondary">
        <span>{d1}</span>
      </h1>
      <h1 className="relative h1 lg:py-4 lg:text-xl border my-3 px-4 border-secondary">
        <span>{d2}</span>
      </h1>
      <h1 className="relative h1 lg:py-4 lg:text-xl border my-3 px-4 border-secondary">
        <span>{d3}</span>
      </h1>
      <h1 className="relative h1 lg:py-4 lg:text-xl border my-3 px-4 border-secondary">
        <span>{d4}</span>
      </h1>
      <h1 className="relative h1 lg:py-4 lg:text-xl border my-3 px-4 border-secondary">
        <span>{d5}</span>
      </h1>
      <h1 className="relative h1 lg:py-4 lg:text-xl border my-3 px-4 border-secondary">
        <span>{d6}</span>
      </h1>
      <a
        target={"_blank"}
        href={live}
        className="btn-success mt-10 btn btn-outline px-10"
      >
        Visit
      </a>
      <a
        target={"_blank"}
        href={git}
        className="btn-success mt-10 ml-3 btn btn-outline px-10"
        type=""
      >
        Github
      </a>
    </div>
  );
};

export default Description;
